<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="品牌名称">
        <el-input v-model="queryForm.brandName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getBrandList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetQueryFrom"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            :disabled="multipleSelection.length > 0"
            @click="addShopBrand(1)"
          >新建</el-button>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            :disabled="multipleSelection.length <= 0"
            @click="deleteShopBrand(null)"
          >删除</el-button>
        </div>

        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshShopBrandList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="shopBrandList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
      >
        <el-table-column
          align="center"
          type="selection"
          min-width="10%"
        > </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="brandName"
          label="品牌名称"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="brandLogo"
          label="品牌Logo"
          min-width="20%"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.brandLogo">
                <el-image
                    @click='updateSrcList(scope.row.brandLogo)'
                    style="width: 30px; height: 30px"
                    :src="scope.row.brandLogo"
                    :preview-src-list="srcList"
                > </el-image>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          min-width="20%"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkShopBrand(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editShopBrand(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteShopBrand(scop.row.id)">
                <Icon
                  size="16"
                  style="color: red"
                >
                  <Delete24Regular />
                </Icon>
                <span
                  class="operation-label"
                  style="color: red"
                >删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog
        :title="shopBrandStates[shopBrandState]"
        :visible.sync="showDialog"
        width="400px"
        @close="closeDialog"
      >
        <div>
          <el-form
            :model="shopBrand"
            ref="shopBrandForm"
            :rules="rules"
            label-width="80px"
            :inline="true"
            size="small"
          >
            <el-form-item
              label="品牌名称"
              prop="brandName"
            >
              <el-input
                size="small"
                style="width: 180px"
                v-model="shopBrand.brandName"
                :disabled="shopBrandState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="品牌Logo"
              prop="brandLogo"
            >
              <el-upload
                action=""
                :disabled="shopBrandState == 'check'"
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="uploadAvatar"
                style="width: 200px"
              >
                <img
                  v-if="shopBrand.brandLogo"
                  :src="shopBrand.brandLogo"
                  class="avatar"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
            v-if="shopBrandState != 'check'"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { get, post, deleteFun, upload } from '@/utils/request.js';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopBrandList();
                this.getBrandList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopBrandList();
                this.getBrandList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                brandName: ''
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentShopBrandId: '',
            shopBrandState: 'add',
            shopBrandStates: {
                add: '新建品牌',
                check: '查看品牌',
                edit: '修改品牌'
            },
            multipleSelection: [],
            shopBrandList: [],
            shopBrand: {
                brandName: '',
                brandLogo: ''
            },
            btnLoading: false,
            status: '', //1 :用户 2 ：职位
            rules: {
                brandName: [{ required: true, message: '品牌名称不能为空', trigger: 'blur' }],
                brandLogo: [{ required: true, message: '品牌Logo不能为空', trigger: 'blur' }]
            },
            srcList:[''],//大图预览
        };
    },
    created() {
        this.getBrandList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopBrandList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopBrandList = [];
        },
        resetDialog() {
            this.shopBrandState = 'add';
            this.showDialog = false;
            this.shopBrand = {
                brandName: '',
                brandLogo: ''
            };
            this.getBrandList();
        },
        closeDialog() {
            this.resetDialog();
            this.$refs.shopBrandForm.resetFields();
        },
        submitForm() {
            if (this.shopBrandState == 'add') {
                this.$refs.shopBrandForm.validate((valid) => {
                    if (valid) {
                        post(`/shop/productbrand/add`, { ...this.shopBrand }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopBrandList();
                                this.closeDialog();
                            }
                        });
                    }
                });
            } else if (this.shopBrandState == 'edit') {
                this.$refs.shopBrandForm.validate((valid) => {
                    if (valid) {
                        post(`/shop/productbrand/edit`, { ...this.shopBrand }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopBrandList();
                                this.closeDialog();
                            }
                        });
                    }
                });
            }
        },

        updateSrcList(src){
            this.srcList[0] = src
        },

        addShopBrand(value) {
            this.showDialog = true;
            this.status = value;
            this.shopBrandState = 'add';
        },
        checkShopBrand(shopBrandId) {
            this.currentShopBrandId = shopBrandId;
            this.getShopBrandById();
            this.showDialog = true;
            this.shopBrandState = 'check';
        },
        editShopBrand(shopBrandId) {
            console.log('shopBrand', shopBrandId);
            if (shopBrandId) {
                this.currentShopBrandId = shopBrandId;
                this.getShopBrandById();
            } else {
                this.shopBrand = { ...this.shopBrand, ...this.multipleSelection[0] };
            }
            this.showDialog = true;
            this.shopBrandState = 'edit';
        },
        deleteShopBrand(shopBrandId) {
            let ids = '';
            if (shopBrandId) {
                ids = shopBrandId;
            } else {
                ids = this.multipleSelection.map((shopBrand) => shopBrand.id).join(',');
            }
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/productbrand/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopBrandList();
                            this.getBrandList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopBrandList() {
            this.resetShopBrandList();
            this.getBrandList();
        },
        getBrandList() {
            this.loading = true;
            get(`/shop/productbrand/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopBrandList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        resetQueryFrom() {
            this.queryForm.brandName = '';
            this.getBrandList();
        },
        getShopBrandById() {
            console.log('this.currentShopBrandId',this.currentShopBrandId);
            get(`/shop/productbrand/get`, { id: this.currentShopBrandId }).then((res) => {
                if (res.success) {
                    this.shopBrand = { ...this.shopBrand, ...res.shopBrand };
                }
            });
        },
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                console.log({ res });
                if (res.success) {
                    this.shopBrand.brandLogo = res.url;
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getBrandList();
        }
    }
};
</script>

<style lang="scss" scoped>

.page-content{
    height: 100%;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
